import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../components/Button';

interface IModalConfirm {
  modalIsOpen: boolean;
  clientNumberOfDaysToRedeem?: string;
  clientUrl: string;
  toggleModal: () => void;
}

export function ModalConfirm({
  modalIsOpen,
  clientNumberOfDaysToRedeem,
  clientUrl,
  toggleModal,
}: IModalConfirm) {
  const navigate = useNavigate();

  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className={styles.alert}
            src="https://i.ibb.co/Lv98nZd/icons8-money-box.gif"
            alt=""
          />
        </div>
        <h2 className="title-modal">Seu resgate foi feito com sucesso!</h2>
        <p className="subtitle-modal">
          Seu resgate foi feito com sucesso! Em {clientNumberOfDaysToRedeem} o
          dinheiro estará na sua conta.
        </p>
      </div>

      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Confirmar"
          type="button"
          color="primary"
          onClick={() => {
            toggleModal();
            navigate(`/_/${clientUrl}`);
          }}
        />
      </div>
    </Modal>
  );
}
